import { database } from "@/firebaseConfig";
import { doc, setDoc, collection } from "firebase/firestore";

import { IRecruiter } from "@/types/formInfo.interface";
import { UploadFileServices } from "./uploadFile.services";

export class OnboardingRecruiterServices {
  static async sendOnboardingRecruiterInformation(
    recruiterData: IRecruiter,
    prevRecruiterData: IRecruiter
  ) {
    console.log(prevRecruiterData);

    const { profileView, status: prevStatus } = prevRecruiterData;

    let urlAvatar = "";
    let urlCompanyLogo = "";

    if (typeof recruiterData.companyInformation.logo === "object") {
      urlCompanyLogo = await UploadFileServices.uploadCompanyLogo(
        recruiterData.companyInformation.logo,
        recruiterData.companyInformation.name
      );
    }

    if (typeof recruiterData.avatar === "object") {
      urlAvatar = await UploadFileServices.uplaodAvatar(
        recruiterData.avatar,
        recruiterData.userId
      );
    }

    let status = process.env.recruiterPendingStatus;
    if (recruiterData.profileView === profileView) {
      console.log("prevRecruiterData.status", prevStatus);
      status = prevStatus;
    }

    const data = {
      ...recruiterData,
      avatar: urlAvatar || recruiterData.avatar,
      companyInformation: {
        ...recruiterData.companyInformation,
        logo: urlCompanyLogo || recruiterData.companyInformation.logo,
      },
      status: recruiterData.profileView
        ? process.env.recruiterApprovedStatus
        : process.env.recruiterPendingStatus,
    };

    try {
      const profileRef = collection(database, "recruiters");
      const userRef = doc(profileRef, recruiterData.userId);
      return await setDoc(userRef, data, { merge: true });
    } catch (error) {
      console.log(error);
    }
  }

  static async sendWatingListInformation(recruiterData: any) {
    const data = {
      ...recruiterData,
    };

    try {
      const profileRef = collection(database, "waitingList");
      const userRef = doc(profileRef, recruiterData?.id);
      return await setDoc(userRef, data, { merge: true });
    } catch (error) {
      console.log(error);
    }
  }
}
